// Import package.json to get the version
import packageJson from "../../package.json"

/**
 * Get the application version from package.json
 * This is kept in sync with git tags by our release script
 */
export const getAppVersion = (): string => {
  return packageJson.version || "dev"
}

/**
 * Get the build date from package.json if available
 */
export const getBuildDate = (): string | undefined => {
  // The field is written by our release script
  // Keep optional for local/dev builds
  const maybeBuildDate = (packageJson as any).buildDate as string | undefined
  return maybeBuildDate
}

/**
 * Get a formatted version string for display
 * Includes 'v' prefix for proper versioning
 */
export const getFormattedVersion = (): string => {
  const version = getAppVersion()
  const withPrefix = version.startsWith("v") ? version : `v${version}`
  const buildDate = getBuildDate()
  return buildDate ? `${withPrefix} (${buildDate})` : withPrefix
}
